// src/components/modalForm/ModalSelectButton.js
import React from 'react';
import { AiOutlineSelect } from 'react-icons/ai';

const ModalSelectButton = ({ children, label, className = '', ...props }) => (
  <button type="button" {...props} className={`btn btn-outline-secondary btn-sm modal-select-button ${className}`.trim()} aria-label={props['aria-label'] || (label ? `Selecionar ${label}` : 'Selecionar registro')}>
    <span className="modal-select-text">Selecionar</span><AiOutlineSelect aria-hidden="true" />
    {children}
  </button>
);

export default ModalSelectButton;
